import Vue from "vue";

export const Ssh = Vue.component("ssh", () =>
    import(/* webpackChunkName: "component_ssh" */ "./contratos/Ssh.vue")
);

export const Geocode = Vue.component("geocode", () =>
    import(/* webpackChunkName: "component_geocode" */ "./contratos/Geocode.vue")
);

export const Place = Vue.component("place", () =>
    import(/* webpackChunkName: "component_place" */ "./contratos/Place.vue")
);

export const Street = Vue.component("street", () =>
    import(/* webpackChunkName: "component_street" */ "./Street.vue")
);

export const Permissoes = Vue.component("permissoes", () =>
    import(/* webpackChunkName: "component_permissoes" */ "./usuarios/Permissoes.vue")
);

export const DadosUsuario = Vue.component("dados-usuario", () =>
    import(/* webpackChunkName: "component_dados_usuario" */ "./usuarios/DadosUsuario.vue")
);

export const Telefones = Vue.component("telefones", () =>
    import(/* webpackChunkName: "component_telefones" */ "./clientes/Telefones.vue")
);

export const StatusPing = Vue.component("status-ping", () =>
    import(/* webpackChunkName: "component_telefones" */ "./contratos/StatusPing.vue")
);

export const StatusBloqueio = Vue.component("status-bloqueio", () =>
    import(/* webpackChunkName: "component_telefones" */ "./contratos/StatusBloqueio.vue")
);

export const ListComandos = Vue.component("status-bloqueio", () =>
    import(/* webpackChunkName: "component_list_comandos" */ "./contratos/ListComandos.vue")
);

export const ListClientesNoSwitch = Vue.component(
    "list-clientes-no-switch",
    () =>
        import(/* webpackChunkName: "component_list_clientes_no_switch" */ "./lists/ListClientesNoSwitch")
);

export const ListClientesNoPacpon = Vue.component(
    "list-clientes-no-pacpon",
    () =>
        import(/* webpackChunkName: "component_list_clientes_no_pacpon" */ "./lists/ListClientesNoPacpon")
);

export const Maps = Vue.component("maps", () =>
    import(/* webpackChunkName: "component_maps" */ "./contratos/Map.vue")
);

export const DadosInternet = Vue.component("dados_internet", () =>
    import(/* webpackChunkName: "component_dados_internet" */ "./contratos/DadosInternet.vue")
);

export const ConcentradorMenu = Vue.component("concentrador-menu", () =>
    import(/* webpackChunkName: "menu_concentrador" */ "../menus/concentrador.vue")
);

export const ContratoMenu = Vue.component("contrato-menu", () =>
    import(/* webpackChunkName: "menu_contrato" */ "../menus/contratos.vue")
);

export const PontoMenu = Vue.component("pontos-menu", () =>
    import(/* webpackChunkName: "menu_pontos" */ "../menus/pontos.vue")
);

export const CaixasMenu = Vue.component("caixas-menu", () =>
    import(/* webpackChunkName: "menu_caixas" */ "../menus/caixas.vue")
);

export const PortaPonMenu = Vue.component("porta-pon-menu", () =>
    import(/* webpackChunkName: "menu_portas-pon" */ "../menus/portas-pon.vue")
);

export const SplittersMenu = Vue.component("splitters-pon-menu", () =>
    import(/* webpackChunkName: "menu_portas-pon" */ "../menus/splitters.vue")
);

export const FibrasMenu = Vue.component("fibras-menu", () =>
    import(/* webpackChunkName: "menu_fibras" */ "../menus/fibras.vue")
);

export const VoltarMenu = Vue.component("voltar-menu", () =>
    import(/* webpackChunkName: "menu_voltar" */ "../menus/voltar.vue")
);

export const CaixasCTOMenu = Vue.component("caixa-cto-menu", () =>
    import(/* webpackChunkName: "menu_caixas_cto" */ "../menus/caixas-cto.vue")
);

export const CaixasSwitchMenu = Vue.component("caixa-switch-menu", () =>
    import(/* webpackChunkName: "menu_caixas_switch" */ "../menus/caixas-switch.vue")
);

export const CaixasPacPonMenu = Vue.component("caixa-pacpon-menu", () =>
    import(/* webpackChunkName: "menu_caixas_pacpon" */ "../menus/caixas-pacpon.vue")
);

export const PlanosInternetMenu = Vue.component("pontos-planos-internet", () =>
    import(/* webpackChunkName: "menu_planos_internet" */ "../menus/planos_internet.vue")
);

export const RepetidorMenu = Vue.component("repetidor-menu", () =>
    import(/* webpackChunkName: "menu_repetidor" */ "../menus/repetidor.vue")
);

export const SmtpMenu = Vue.component("smtp-menu", () =>
    import(/* webpackChunkName: "menu_smtp" */ "../menus/smtp.vue")
);

export const CaixaEmendaMenu = Vue.component("caixa-emenda-menu", () =>
    import(/* webpackChunkName: "menu_caixa_emenda" */ "../menus/caixa-emenda.vue")
);

export const ReservaTecnicaMenu = Vue.component("reserva-tecnica-menu", () =>
    import(/* webpackChunkName: "menu_reserva_tecnica" */ "../menus/reserva_tecnica.vue")
);

export const CaixaConectorMenu = Vue.component("caixa-conector-menu", () =>
    import(/* webpackChunkName: "menu_caixa_conector" */ "../menus/caixa-conector.vue")
);

export const ModeloSwitchMenu = Vue.component("modelo-switch-menu", () =>
    import(/* webpackChunkName: "menu_modelo_switch" */ "../menus/modelo-switch")
);

export const ListBloqueados = Vue.component("list-bloqueados", () =>
    import(/* webpackChunkName: "component_list_bloqueados" */ "./contratos/ListBloqueados.vue")
);

export const ListOfflines = Vue.component("list-offlines", () =>
    import(/* webpackChunkName: "component_list_offlines" */ "./contratos/ListOfflines.vue")
);

export const ListCacontrol = Vue.component("list-offlines", () =>
    import(/* webpackChunkName: "component_list_cacontrol" */ "./contratos/ListCacontrol.vue")
);

export const ListUsuarios = Vue.component("list-usuarios", () =>
    import(/* webpackChunkName: "component_list_usuarios" */ "./contratos/ListUsuarios.vue")
);

export const AllMaps = Vue.component("all_maps", () =>
    import(/* webpackChunkName: "component_all_maps" */ "./maps/AllMaps.vue")
);

export const NovoBoleto = Vue.component("novo-boleto", () =>
    import(/* webpackChunkName: "component_novo_boleto" */ "./financeiro/NovoBoleto.vue")
);

export const CurrencyInput = Vue.component("currency_input", () =>
    import(/* webpackChunkName: "component_currency_input" */ "./currency-input.vue")
);

export const ListContratos = Vue.component("list_contratos", () =>
    import(/* webpackChunkName: "component_list_contratos" */ "./lists/contratos/ListContratos.vue")
);

export const ListContratosSemLatLong = Vue.component(
    "list_contratos_sem_ll",
    () =>
        import(/* webpackChunkName: "component_list_contratos_sem_ll" */ "./lists/contratos/ListContratosSemLatLong.vue")
);

export const ListContratosSemMac = Vue.component(
    "list_contratos_sem_mac",
    () =>
        import(/* webpackChunkName: "component_list_contratos_sem_mac" */ "./lists/contratos/ListContratosSemMac")
);

export const ListContratosSemCaixa = Vue.component(
    "list_contratos_sem_caixa",
    () =>
        import(/* webpackChunkName: "component_list_contratos_sem_caixa" */ "./lists/contratos/ListContratosSemCaixa.vue")
);

export const ListCtoByFibra = Vue.component("List_cto_by_fibra", () =>
    import(/* webpackChunkName: "component_List_cto_by_fibra" */ "./lists/ListCTOByFibra.vue")
);

export const ListCTOByPortaPON = Vue.component("List_cto_by_fibra", () =>
    import(/* webpackChunkName: "component_List_cto_by_porta_pon" */ "./lists/ListCTOByPortaPON")
);

export const StatusDaOnu = Vue.component("List_cto_by_fibra", () =>
    import(/* webpackChunkName: "component_status_da_onu" */ "./onu/StatusDaONU")
);
